import React, { useEffect, useState, memo, lazy, Suspense } from 'react';
import './TocDialog.css';
import { parseCSV } from '../../types/lib/csvConverter';
import { tOSViewStateAtom, ViewState } from '../../atoms';
import { useAtom } from 'jotai';
import SquareButton from '../button/SquareButton';
// FormatTextを遅延読み込み
const FormatText = lazy(() => import('../../lib/FormatText').then(module => ({ default: module.FormatText })));

// シンプルなテキスト表示用コンポーネント（FormatTextが読み込まれるまでの代替として使用）
const SimpleText = ({ text }: { text: string }) => <>{text}</>;

// コンテンツアイテムをメモ化
const ContentItem = memo(({ section, title, content }: { section: string, title: string, content: string }) => (
  <div className='messageItem'>
    <p className='title'>
      <span>{section}</span>
      <FormatText text={title} />
    </p>
    <p className='content'>
      <Suspense fallback={<SimpleText text={content} />}>
        <FormatText text={content} />
      </Suspense>
    </p>
  </div>
));

const TOCDialog: React.FC = () => {

  const [text, setText] = useState<string | undefined>(undefined);
  const [contents, setContents] = useState<{[key: string]: string}[] | undefined>(undefined);
  const [references, setReferences] = useState<string| undefined>(undefined);

  const [tOSViewState, setTOSViewState] = useAtom(tOSViewStateAtom);

  /* *****************
   * 利用規約を取得
   * *****************/
  useEffect(() => {
    const fetchData = async () => {
      try {
          const [descriptionResponse, contentResponse, referencesResponse] = await Promise.all([
            fetch('https://raw.githubusercontent.com/yaizu-city/app/main/利用規約/説明.csv'),
            fetch('https://raw.githubusercontent.com/yaizu-city/app/main/利用規約/コンテンツ.csv'),
            fetch('https://raw.githubusercontent.com/yaizu-city/app/main/利用規約/出展.csv')
          ]);
  
          const descriptionText = await descriptionResponse.text();
          const contentText = await contentResponse.text();
          const referenceText = await referencesResponse.text();
  
          // 取得したデータを使用する処理
          setText(descriptionText);
          setContents(parseCSV(contentText));
          setReferences(referenceText);

      } catch (error) {
          console.error('Error fetching data:', error);
      }
    };

    fetchData();

  }, []);

  if(tOSViewState === ViewState.FirstClosed || tOSViewState === ViewState.Closed) {  return null; }

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <h2>利用規約</h2>
        <div className='contents'>
          <p className='description'>{text}</p>
          { contents &&
            contents.map((key) => (
              <ContentItem 
                key={key.Section}
                section={key.Section} 
                title={key.Title} 
                content={key.Content} 
              />
            ))
          }
          { references && 
            <>
              <p>【出典】</p>
              <p>
                <Suspense fallback={<SimpleText text={references} />}>
                  <FormatText text={references} />
                </Suspense>
              </p>
            </>
          }
        </div>
        <div className='btn-area'>
          <SquareButton 
            label={tOSViewState === ViewState.FirstView ? '同意する' : '閉じる'}
            onClick={() => setTOSViewState((prev) =>
              prev === ViewState.FirstView ? ViewState.FirstClosed : ViewState.Closed
            )} 
          />
        </div>
      </div>
    </div>
  );
};

export default TOCDialog;
